import {
  AfterViewInit,
  Component,
  ElementRef,
  Signal,
  viewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { IonInput } from '@ionic/angular/standalone';
import { firstValueFrom, ReplaySubject } from 'rxjs';
import { delay } from 'rxjs/operators';
import { OnLoaded } from '@lyceo/shared/dynamic-component-loading/feature-main';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-gap',
  templateUrl: './gap.component.html',
  styleUrls: ['./gap.component.scss'],
  imports: [IonInput, ReactiveFormsModule],
})
export class GapComponent implements AfterViewInit, OnLoaded {
  public readonly input: Signal<ElementRef> = viewChild.required(IonInput, {
    read: ElementRef,
  });

  /**
   * inner form for the gap input.
   */
  public gapControl: UntypedFormControl = new UntypedFormControl();

  /**
   * Subject which starts to emit when the view is rendered. This is needed because the
   * component is dynamically loading. In {@see GapMatchQuestionComponent.replaceGapFields}
   * we add the {@see GapComponent.gapControl} to the FormArray of gaps but before we can do
   * that we need to wait until the component has finished loading.
   */
  public onFinishedInit$: ReplaySubject<void> = new ReplaySubject<void>();

  /**
   * @inheritDoc
   */
  public ngAfterViewInit(): void {
    this.onFinishedInit$.next();
    this.onFinishedInit$.complete();
  }

  /**
   * @inheritDoc
   */
  public ready(): Promise<void> {
    return firstValueFrom(this.onFinishedInit$.pipe(delay(20)));
  }

  public setFocus(): void {
    this.input().nativeElement.setFocus();
  }
}
